import { IconProps } from "@/components/Icons/index";

export const AIModelsLogo: React.FC<IconProps> = (props) => {
  return <img src="/assets/images/model.png" alt="intelligence" {...props} />;
};

export const AIModelsLogoLight: React.FC<IconProps> = (props) => {
  return <img src="/assets/images/intelligence-logo-light.png" alt="intelligence" {...props} />;
};
